import { render, staticRenderFns } from "./InstitutionPolicyView.vue?vue&type=template&id=40e44120&scoped=true"
import script from "./InstitutionPolicyView.vue?vue&type=script&lang=js"
export * from "./InstitutionPolicyView.vue?vue&type=script&lang=js"
import style0 from "./InstitutionPolicyView.vue?vue&type=style&index=0&id=40e44120&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e44120",
  null
  
)

export default component.exports